const MS_DAY = 86400000;
const MS_90 = 90 * MS_DAY;

const MILESTONES = [
  { days: 30, icon: '🏆' },
  { days: 21, icon: '🥇' },
  { days: 14, icon: '🥈' },
  { days: 7,  icon: '🔥' },
];

function monthKey(date) {
  const d = new Date(date);
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
}

function monthlyRate(txns, incomeList, year, month) {
  const key = year + '-' + String(month + 1).padStart(2, '0');
  let income = 0;
  let expenses = 0;
  for (const t of txns) {
    if (!t || !t.date || monthKey(t.date) !== key) continue;
    const amt = Number(t.amount) || 0;
    if (incomeList && incomeList.includes(t.category)) {
      income += amt;
    } else {
      expenses += amt;
    }
  }
  if (income <= 0) return null;
  return ((income - expenses) / income) * 100;
}

export function buildAchievements(allTxns, selMonth, selYear, incomeList, savingsRate) {
  const now = Date.now();
  const achievements = [];

  // Part A: streak milestones
  const expenseTxns90 = (allTxns || []).filter(t => {
    if (!t || !t.date || !t.category) return false;
    if (incomeList && incomeList.includes(t.category)) return false;
    if (t.type === 'income') return false;
    const ms = new Date(t.date).getTime();
    return ms >= now - MS_90 && ms <= now;
  });

  const spendByCat = {};
  const lastMsByCat = {};
  for (const t of expenseTxns90) {
    const cat = t.category;
    const ms = new Date(t.date).getTime();
    spendByCat[cat] = (spendByCat[cat] || 0) + (Number(t.amount) || 0);
    if (!lastMsByCat[cat] || ms > lastMsByCat[cat]) lastMsByCat[cat] = ms;
  }

  const streakCandidates = Object.entries(lastMsByCat)
    .filter(([cat]) => (spendByCat[cat] || 0) >= 50)
    .map(([cat, lastMs]) => {
      const days = Math.floor((now - lastMs) / MS_DAY);
      const milestone = MILESTONES.find(m => days >= m.days);
      return { cat, days, milestone };
    })
    .filter(s => s.milestone)
    .sort((a, b) => b.days - a.days)
    .slice(0, 2);

  for (const { cat, days, milestone } of streakCandidates) {
    achievements.push({
      icon: milestone.icon,
      color: '#7c3aed',
      text: days + ' days without ' + String(cat) + '!' +
        (milestone.days >= 30 ? ' That\'s a full month streak.' : ''),
    });
  }

  // Part B: savings rate record (best this year)
  const rate = Number(savingsRate) || 0;
  if (rate < 20) return achievements;

  let bestPrior = -Infinity;
  for (let m = 0; m < selMonth; m++) {
    const r = monthlyRate(allTxns || [], incomeList, selYear, m);
    if (r !== null && r > bestPrior) bestPrior = r;
  }

  if (rate > bestPrior) {
    achievements.push({
      icon: '🎉',
      color: '#7c3aed',
      text: 'You saved ' + Math.round(rate) + '% of your income this month — best rate this year!',
    });
  }

  return achievements;
}
